// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"032787b9","754":"cd64e354"}[chunkId] + ".chunk.css";
};